<script setup lang="ts">
interface Props {
  titleClass?: string;
  fullWidth?: boolean;
}

const props = defineProps<Props>();
</script>

<template>
  <section :class="`${$style.root} ${props.fullWidth ? '' : 'container'}`">
    <h2
      v-if="$slots.title"
      :class="props.titleClass"
    >
      <slot name="title" />
    </h2>
    <slot />
  </section>
</template>

<style lang="scss" module>
.root {
  @apply flex flex-col gap-10 items-center w-full;
}
</style>
